<template>
  <nav class="modern-primary-navigation" aria-label="Navegación principal">
    <template v-for="item in primaryItems">
      <router-link
        v-if="item.available"
        :key="item.id"
        class="modern-primary-navigation__item"
        :class="{ 'is-active': isActive(item) }"
        :to="{ name: item.routeName }"
      >{{ item.label }}</router-link>
      <button
        v-else
        :key="item.id"
        class="modern-primary-navigation__item is-disabled"
        type="button"
        disabled
        :aria-label="`${item.label}, próximamente`"
      >{{ item.label }} <span>Próximamente</span></button>
    </template>

    <div class="modern-primary-navigation__more">
      <button type="button" aria-haspopup="menu" :aria-expanded="String(moreOpen)" @click="moreOpen = !moreOpen">
        Más <span aria-hidden="true">⌄</span>
      </button>
      <div v-if="moreOpen" class="modern-primary-navigation__more-menu" role="menu">
        <button v-for="item in pendingItems" :key="item.id" type="button" role="menuitem" disabled>
          {{ item.label }} <small>Próximamente</small>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { MODERN_NAVIGATION, isModernNavigationItemActive } from '@/shells/models/modernNavigation';

export default {
  name: 'ModernPrimaryNavigation',
  data: () => ({ items: MODERN_NAVIGATION, moreOpen: false }),
  computed: {
    primaryItems() { return this.items; },
    pendingItems() { return this.items.filter(item => !item.available); }
  },
  watch: {
    '$route.fullPath'() { this.moreOpen = false; }
  },
  methods: {
    isActive(item) { return isModernNavigationItemActive(item, this.$route); }
  }
};
</script>
